import request from '@/utils/request';

export default class Base {
  // 获取用户列表
  public static getUserList(userName, currPage, pageSize) {
    return request.get(`/api/user/list`,
      {
        params: {
          userName,
          currPage,
          pageSize,
        }
      }
    );
  }
  // 获取用户详情通过ID
  public static getUserById(userId) {
    return request.get(`/api/user/${userId}`);
  }
  // 编辑用户
  public static editUser(params: object) {
    return request.put(`/api/user`, params);
  }
  // 获取角色列表
  public static getRoleList(roleName, currPage, pageSize) {
    return request.get(`/api/role/list`,
      {
        params: {
          roleName,
          currPage,
          pageSize
        }
      }
    );
  }
  // 获取字典表
  public static getDicts(name: string) {
    return request.get(`/api/dict/list`, {
      params: {
        categoryName: name
      }
    });
  }
  // 获取省份
  public static getVprovinceList(currPage, pageSize) {
    return request.get(`/api/vProvince/list`, {
      params: {
        currPage,
        pageSize
      }
    });
  }
  // 获取地市
  public static getVcityList(currPage, pageSize) {
    return request.get(`/api/vCity/list`, {
      params: {
        currPage,
        pageSize
      }
    });
  }
  // 获取线上资源对象通过ID
  public static getResourceById(id: string) {
    return request.get(`/api/resource/${id}`);
  }
  // 删除线上线下资源通过ID
  public static deleteResourceById(id: string) {
    return request.delete(`/api/resource/${id}`);
  }
  // 获取线上线下操作记录
  public static getImportRecordList(fileName, fileType, currPage, pageSize) {
    return request.get(`/api/importRecord/list`, {
      params: {
        fileName,
        fileType,
        currPage,
        pageSize
      }
    });
  }
}
